import {
  authActions,
  authWorkspaceActions,
  authWorkspaceGuardActions,
  boAuthActions,
} from '@mkp/auth/actions';
import {
  createFeature,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

export enum WorkspaceFromUrlStatus {
  INIT = 'INIT',
  COMPLETED = 'COMPLETED',
  LOADING = 'LOADING',
  LOGGED_OUT = 'LOGGED_OUT',
}

interface State {
  workspaceFromUrlStatus: WorkspaceFromUrlStatus;
}

const initialState: State = {
  workspaceFromUrlStatus: WorkspaceFromUrlStatus.INIT,
};

const featureKey = 'auth';

export const reducer = createReducer(
  initialState,
  on(authWorkspaceActions.workspaceSelectionRequired, () => ({
    workspaceFromUrlStatus: WorkspaceFromUrlStatus.LOADING,
  })),
  on(
    authWorkspaceActions.workspaceSelectionNotRequired,
    authWorkspaceActions.unguardedRoute,
    authWorkspaceGuardActions.redirectedOnNoSelectedWorkspace,
    authWorkspaceGuardActions.workspaceSelectionNotRequired,
    authActions.workspaceSelected,
    authActions.workspaceFoundInStore,
    authActions.loadWorkspaceCompanySuccess,
    authActions.loadWorkspaceCompanyError,
    authActions.loadWorkspaceAccountError,
    boAuthActions.loadWorkspaceError,
    () => ({
      workspaceFromUrlStatus: WorkspaceFromUrlStatus.COMPLETED,
    })
  ),
  on(authActions.appBootstrapFailed, () => ({
    workspaceFromUrlStatus: WorkspaceFromUrlStatus.LOGGED_OUT,
  }))
);

const feature = createFeature({
  name: featureKey,
  reducer,
});

const selectFeature = createFeatureSelector<State>(featureKey);
export const selectWorkspaceFromUrlStatus = createSelector(
  selectFeature,
  (state: State) => state.workspaceFromUrlStatus
);
export const authFeature = { ...feature };
export { State as AuthState };
